import React from 'react';
import PropTypes from 'prop-types';

const MAX_TICKETS_TIER = 200;

const TicketsLeft = ({messageFormatter, className, tier, totalTickets, message, messageMany}) => {
  const FormattedMessage = messageFormatter;

  return totalTickets >= 0 ? (
    <div className={className} data-tier={tier}>
      <span>
        {totalTickets <= MAX_TICKETS_TIER ? (
          <FormattedMessage {...message} values={{totalTickets}} />
        ) : (
          <FormattedMessage {...messageMany} />
        )}
      </span>
    </div>
  ) : null;
};

TicketsLeft.propTypes = {
  /** Classname to add to the wrapper */
  className: PropTypes.string,

  /** Tickets left tier */
  tier: PropTypes.number,

  /** Total number of tickets left */
  totalTickets: PropTypes.number,

  /** Message descriptor to be shown when there are less than 200 tickets */
  message: PropTypes.object.isRequired,

  /** Message descriptor to be shown when there are many tickets */
  messageMany: PropTypes.object.isRequired,

  /** The message formatter that should receive at least id and defaultMessage */
  messageFormatter: PropTypes.node.isRequired,
};

export default TicketsLeft;
